<main class="mat-body" *ngIf="contract">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12">
                <thr-contract-progress [percent]="30"></thr-contract-progress>
            </div>
        </div>
    </div>

    <form #formSign="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row flex-nowrap justify-content-between align-items-end">
                        <div class="col-auto flex-shrink-1">
                            <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'sign.choose-signature-type'|translate"></h1>
                        </div>
                        <div class="col-auto">
                            <i class="icon-sign-natural text-blue" *ngIf="!isLegalPerson"></i>
                            <i class="icon-sign-legal text-blue" *ngIf="isLegalPerson"></i>
                        </div>
                    </div>
                    <hr class="mt-1 mb-0" />
                </div>
            </div>
        </div>

        <div class="bg-blue-gradient mb-3">
            <div class="container">
                <thr-radio-group name="signature-type" [(ngModel)]="contract.signatureType" [required]="true">
                    <div class="row align-items-center py-3" *ngIf="!isLegalPerson">
                        <div class="col-12 col-md-4 col-lg-3">
                            <p class="font-weight-bold text-blue mb-4 mb-md-0">{{ 'sign.description-signature-type'|translate }}</p>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 offset-lg-1">
                            <thr-radio-button name="sole" class="justify-content-center" [size]="148" [value]="ContractSignatureType.SOLE">
                                <i class="icon-pen"></i>
                                <span [innerHTML]="'sign.sole-signature'|translate"></span>
                            </thr-radio-button>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <thr-radio-button
                                name="joint"
                                class="justify-content-center"
                                [size]="148"
                                [value]="ContractSignatureType.JOINT"
                                [disabled]="signatories.length === 1"
                            >
                                <i class="icon-pens"></i>
                                <span [innerHTML]="'sign.joint-signature'|translate"></span>
                            </thr-radio-button>
                        </div>
                    </div>

                    <div class="row align-items-center py-3 sign-legal-icons" *ngIf="isLegalPerson">
                        <div class="col-12 col-lg-3" [class.col-md-4]="isClientPortal">
                            <p class="font-weight-bold text-blue mb-4 mb-lg-0">{{ 'sign.description-signature-type-legal'|translate }}</p>
                        </div>
                        <div
                            class="col-12"
                            [ngClass]="{'col-sm-4 col-lg-3': !isClientPortal, 'col-sm-6 col-md-4 offset-lg-1': isClientPortal}"
                        >
                            <thr-radio-button name="sole" class="justify-content-center" [size]="148" [value]="ContractSignatureType.SOLE">
                                <i class="icon-pen"></i>
                                <span [innerHTML]="'sign.sole-signature-legal'|translate"></span>
                            </thr-radio-button>
                        </div>
                        <div class="col-12" [ngClass]="{'col-sm-4 col-lg-3': !isClientPortal, 'col-sm-6 col-md-4': isClientPortal}">
                            <thr-radio-button
                                name="joint"
                                class="justify-content-center"
                                [size]="148"
                                [value]="ContractSignatureType.JOINT"
                                [disabled]="signatories.length === 1"
                            >
                                <i class="icon-pens"></i>
                                <span [innerHTML]="'sign.legal-joint-signature'|translate"></span>
                            </thr-radio-button>
                        </div>
                        <div class="col-12 col-sm-4 col-lg-3 red-circle" *ngIf="!isClientPortal">
                            <thr-radio-button
                                name="conditional_joint"
                                class="justify-content-center"
                                [size]="148"
                                [value]="ContractSignatureType.CONDITIONAL_JOINT"
                                [disabled]="signatories.length === 1 || contract.isAdvisoryModelGDC()"
                            >
                                <i class="icon-pens"></i>
                                <span [innerHTML]="'sign.conditional-joint-signature'|translate"></span>
                            </thr-radio-button>
                        </div>
                    </div>
                </thr-radio-group>
            </div>
        </div>

        <div class="container">
            <div class="row" *ngIf="isLegalPerson && contract.signatureType === ContractSignatureType.CONDITIONAL_JOINT">
                <div class="col-1">
                    <i class="icon-exclamation red-icon-exclamation"></i>
                </div>
                <div class="col-11">
                    <p class="text-error font-weight-bold">{{ 'sign.conditional-signature-alert'|translate }}</p>
                </div>
                <div class="col-12">
                    <mat-form-field class="full-width">
                        <input
                            name="signatureCondition"
                            matInput
                            [placeholder]="'sign.conditional-joint-signature-alert'|translate"
                            [(ngModel)]="contract.signatureCondition"
                            #signatureConditionCtrl="ngModel"
                            required
                        />
                        <mat-error *ngIf="signatureConditionCtrl.hasError('required')">
                            {{ 'form.validation.required'|translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <h2
                        *ngIf="!contract.isAdvisoryModelSuitabilityOrGDC()"
                        class="text-blue mat-display-1"
                        [innerHTML]="'sign.choose-appropriateness-test'|translate"
                    ></h2>
                    <h2
                        *ngIf="contract.isAdvisoryModelSuitabilityOrGDC()"
                        class="text-blue mat-display-1"
                        [innerHTML]="'sign.choose-ideoneity-test'|translate"
                    ></h2>
                    <h2 class="mat-subheading-1 text-blue font-weight-bold my-3">{{ 'form.participants'|translate }}</h2>

                    <mat-radio-group name="signatory" [(ngModel)]="signatory" (ngModelChange)="onSignatoryChange()" [required]="true">
                        <table class="table participants">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th class="d-none d-md-table-cell">{{ 'form.participants'|translate }}</th>
                                    <th>{{ 'sign.name-surname-and-document'|translate }}</th>
                                    <th class="d-none d-md-table-cell">{{ 'sign.phone-and-email'|translate }}</th>
                                    <th class="text-right">{{ 'sign.appropriateness-profile'|translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-template ngFor let-signatory [ngForOf]="signatories" let-i="index">
                                    <tr>
                                        <td class="text-center">
                                            <mat-radio-button
                                                [name]="'signatory' + i"
                                                color="blue-gray"
                                                [value]="signatory"
                                            ></mat-radio-button>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <ng-container *ngIf="signatory.isAttorneyInFact">
                                                <strong class="text-uppercase text-blue">{{ 'form.attorney-in-fact'|translate }}</strong>
                                            </ng-container>
                                            <ng-container *ngIf="!signatory.isAttorneyInFact" [ngSwitch]="signatory.relation">
                                                <strong class="text-uppercase text-blue" *ngSwitchCase="ClientRelation.AUTHORIZED"
                                                    >{{ 'form.authorized'|translate }}</strong
                                                >
                                                <strong class="text-uppercase text-blue" *ngSwitchDefault>
                                                    <ng-container *ngIf="signatory.isSoleHolder"
                                                        >{{ 'form.holder'|translate }}</ng-container
                                                    >
                                                    <ng-container *ngIf="!signatory.isSoleHolder"
                                                        >{{ 'form.co-holder'|translate }}</ng-container
                                                    >
                                                </strong>
                                            </ng-container>
                                        </td>
                                        <td>
                                            <strong>{{ signatory.name }}</strong>&nbsp;<strong>{{ signatory.surname }}</strong><br />
                                            <strong>{{ signatory.docId }}</strong>
                                        </td>
                                        <td class="d-none d-md-table-cell">
                                            <strong>{{ signatory.phone }}</strong><br />
                                            <strong>{{ signatory.email }}</strong>
                                        </td>
                                        <td class="text-right">
                                            <strong class="text-uppercase text-blue" *ngIf="signatory.mifidCompetenceName">
                                                {{ signatory.mifidCompetenceName }}
                                            </strong>
                                            <strong class="text-uppercase text-blue" *ngIf="!signatory.mifidCompetenceName">
                                                {{ 'sign.appropriateness-profile-level.none'|translate }}
                                            </strong>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </mat-radio-group>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row justify-content-end my-4">
                <div class="col-12" *ngIf="isClientPortal">
                    <div
                        #recaptchaDirective="recaptcha"
                        thr-recaptcha
                        name="recaptcha"
                        [(ngModel)]="recaptchaToken"
                        #recaptchaCtrl="ngModel"
                    ></div>
                </div>
                <div class="col-10 col-sm-6 col-md-4">
                    <button
                        type="submit"
                        class="full-width mat-elevation-z0"
                        mat-raised-button
                        color="gray"
                        [disabled]="!formSign.valid || !canContinue"
                    >
                        {{ 'general.next'|translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</main>
